import { useState, useEffect } from "react";
import { useStepContext } from "../../utils/StepContext.jsx"; 
import { useFormContext } from "../../utils/FormContext.jsx"; 
import { useMediaQuery } from 'react-responsive';
import { useAuth } from "../../utils/AuthContext/AuthContext.jsx"; 

import MainCard from "../MainCard.jsx";
import ProgressBar from "../ProgressBar/ProgressBar.jsx";

import InfoSVG from "../../assets/InfoSVG.jsx";
import CheckmarkSVG from "../../assets/Checkmark.jsx";
import CompletedSVG from "../../assets/Completed.jsx";
import SaveButton from "../SaveButton.jsx"; 
import PDFPreview from "../PDFPreview.jsx";
import HelpButton from "../HelpButton.jsx";
import ShishitoAssist from "../ShishitoAssist/ShishitoAssist.jsx";

const PreStepMiscellaneous = () => {

    const currentPageValue = 0;
    const currentSubStepProgress = 4/5; 

    const { handleNext, handleBack, markStepAsComplete, unsetStepAsComplete } = useStepContext();
    const { token, user } = useAuth();
    const [isAssistVisible, setIsAssistVisible] = useState(false);
    const { formData, setFormData, formId, handleItemToggle, handleStatusChange, handleCheckboxChange } = useFormContext(); 

    const isMobile = useMediaQuery({ query: '(max-width: 768px)' }); 
    
    const onBack = () => {
        unsetStepAsComplete(currentPageValue);
        handleBack();
    };

    const onNext = () => {
            markStepAsComplete(currentPageValue); // Mark this step as complete
            handleNext(); // Navigate to the next step
    };

    const toggleAssist = () => {
        setIsAssistVisible(!isAssistVisible);
    };

    const [propertyItems, setPropertyItems] = useState({
        ...formData.inclusionsPreStep
    });

    useEffect(() => {
        setPropertyItems({ ...formData.inclusionsPreStep });
    }, [formData]);

    const updateInclusionsText = () => {
        let encumberedInclusionsValues = '';
        let leasedItemsValues = '';

        const validItems = ['solarPanels', 'waterSofteners', 'securitySystems', 'satelliteSystems'];

        Object.entries(formData.inclusionsPreStep).forEach(([item, data]) => {
            if (data.included && validItems.includes(item)) {
                const itemText = item.replace(/([A-Z])/g, ' $1').toLowerCase();
                if (data.status === 'financed' || data.status === 'unsure' || data.status === null) {
                    encumberedInclusionsValues += `${itemText}, `;
                }
                if (data.status === 'leased' || data.status === 'unsure' || data.status === null) {
                    leasedItemsValues += `${itemText}, `;
                }
            }
        });

        encumberedInclusionsValues = encumberedInclusionsValues.slice(0, -2); // Remove trailing comma and space
        leasedItemsValues = leasedItemsValues.slice(0, -2); // Remove trailing comma and space

        // Only update state if there are actual changes
        if (formData.inclusionsPreStep.encumberedInclusionsValues !== encumberedInclusionsValues ||
            formData.inclusionsPreStep.leasedItemsValues !== leasedItemsValues) {
            setFormData(prev => ({
                ...prev,
                inclusionsPreStep: {
                    ...prev.inclusionsPreStep,
                    encumberedInclusionsValues,
                    leasedItemsValues,
                }
            }));
        }
    };

    useEffect(() => {
        updateInclusionsText();
    }, [formData.inclusionsPreStep, setFormData]);

    const handleCardClick = (item) => {
        handleItemToggle(item);
    };

    const handleCheckboxClick = (e) => {
        e.stopPropagation();
    };

    return (
        <div className="w-full flex flex-col h-screen bg-shi-eggshell items-center">
        {/* <ProgressBar currentPage={currentPageValue} subStepProgress={currentSubStepProgress}/> */}
        <MainCard width={750} maxHeight={450} gap={0}>
        <div className="overflow-y-auto md:max-h-[425px] max-h-[75vh] w-full">
            <div className="flex flex-col">
                <div className='inline-flex justify-between items-center w-full mb-5'>
                    {isMobile ? <h3 className="text-black text-[18px] text-left font-normal font-['Inter']">Misc. Pre-Screen</h3> : <h3 className="text-black text-xl text-left font-normal font-['Inter']">Inclusions, Water & Well Pre-Screen</h3>}
                    <div className='gap-2 md:gap-4 items-center h-auto inline-flex'>
                        <HelpButton onClick={toggleAssist}/>
                        <SaveButton formData={formData} formId={formId}/>
                        {user && <PDFPreview formData={formData}/>}
                    </div>
                </div>
                <div className="border-blue-500 bg-blue-50 border rounded-md md:p-2 p-1 inline-flex justify-between w-full gap-2">
                    {isMobile ? <InfoSVG width={18} height={18} fill='#2563EB'/> : <InfoSVG width={23} height={23} fill='#2563EB'/>}
                    <span className="text-blue-800 text-[13px] w-full">
                        Select items you know are part of the property. If unsure, leave unchecked and ask the seller about leased or financed items, including those not listed (e.g., HVAC or appliances).
                    </span>
                </div>

                <div className="grid grid-cols-1 gap-4 mt-4">
                    {Object.entries(formData.inclusionsPreStep)
                    .filter(([item]) => item !== 'encumberedInclusionsValues' && item !== 'leasedItemsValues' && item !== 'encumberedInclusionsManualText' && item !== 'leasedItemsManualText')
                    .map(([item, data]) => (
                                <div 
                                    key={item} 
                                    className={`cursor-pointer transition-colors ${data.included ? 'border-blue-500 border-[3px]' : 'hover:border-gray-400 border' } rounded-lg shadow-sm p-2`} 
                                    onClick={() => handleCardClick(item)}
                                >   
                                    <div className="flex items-center w-full">
                                        <h1 className="flex items-center justify-between w-full">
                                            <div className="w-full flex flex-col gap-1 mb-2">
                                                <div className="inline-flex w-full justify-between">
                                                    <span className="capitalize font-semibold">{item.replace(/([A-Z])/g, ' $1')}</span>
                                                    {data.included ? <div className="inline-flex items-center gap-1"><div className="md:text-[12px] text-[11px] border-green-800 border bg-green-50 rounded-lg md:p-1 p-[1px] text-green-800">INCLUDED</div>{isMobile ? <CompletedSVG width={18} height={18}/> : <CompletedSVG width={25} height={25} />} </div> : <div className="flex items-center md:text-[12px] text-[11px] bg-gray-50 border rounded-lg md:p-1 p-[1px]">NOT INCLUDED</div>}
                                                </div>
                                                <span className="text-gray-600 md:text-[13px] text-[12px]">{data.description}</span>
                                            </div>
                                        </h1>
                                    </div>

                            {data.included && (
                                <div className="flex-col gap-1">
                                    {item !== 'waterRights' && item !== 'wellRights' && (
                                        <div className="space-y-2">
                                            <div className="flex items-center md:space-x-2 space-x-1">
                                                <input
                                                    type="checkbox"
                                                    value="leased"
                                                    id={`${item}-leased`}
                                                    checked={data.status === 'leased'}
                                                    onChange={() => handleStatusChange(item, 'leased')}
                                                    onClick={handleCheckboxClick}
                                                />
                                                <label className="md:text-[16px] text-[14px]" htmlFor={`${item}-leased`}>Leased</label>
                                            </div>
                                            <div className="flex items-center md:space-x-2 space-x-1">
                                                <input
                                                    type="checkbox"
                                                    value="paid"
                                                    id={`${item}-paid`}
                                                    checked={data.status === 'paid'}
                                                    onChange={() => handleStatusChange(item, 'paid')}
                                                    onClick={handleCheckboxClick}
                                                />
                                                <label className="md:text-[16px] text-[14px]" htmlFor={`${item}-paid`}>Fully Paid Off</label>
                                            </div>
                                            <div className="flex items-center md:space-x-2 space-x-1">
                                                <input
                                                    type="checkbox"
                                                    value="financed"
                                                    id={`${item}-financed`}
                                                    checked={data.status === 'financed'}
                                                    onChange={() => handleStatusChange(item, 'financed')}
                                                    onClick={handleCheckboxClick}
                                                />
                                                <label className="md:text-[16px] text-[14px]" htmlFor={`${item}-financed`}>Financed/Not Paid Off</label>
                                            </div>
                                            <div className="flex items-center md:space-x-2 space-x-1">
                                                <input
                                                    type="checkbox"
                                                    value="unsure"
                                                    id={`${item}-unsure`}
                                                    checked={data.status === 'unsure'}
                                                    onChange={() => handleStatusChange(item, 'unsure')}
                                                    onClick={handleCheckboxClick}
                                                />
                                                <label className="md:text-[16px] text-[14px]" htmlFor={`${item}-unsure`}>Not Sure</label>
                                            </div>
                                            {item === 'solarPanels' && (
                                                <div className="space-y-4 bg-gray-50 p-3 rounded-lg">
                                                    <h2 className="text-sm text-slate-700">Additional Items</h2>
                                                    <div className="solar-power-plan">
                                                        <h3 className="text-sm font-semibold">Solar Power Plan</h3>
                                                        <h4 className="mb-2 text-sm text-slate-500">Financial agreement that allows a homeowner to use solar power without owning the solar panels</h4>
                                                        <div className="flex items-center space-x-2">
                                                            <input
                                                                type="checkbox"
                                                                id={`${item}-solarPowerPlan`}
                                                                checked={data.solarPowerPlan}
                                                                onChange={() => handleCheckboxChange(item, 'solarPowerPlan')}
                                                                onClick={handleCheckboxClick}
                                                                className="rounded focus:ring-blue-500"
                                                            />
                                                            <label className="md:text-[14px] text-[13px] text-gray-700" htmlFor={`${item}-solarPowerPlan`}>Check if the seller has a Solar Power Plan on the solar panels</label>
                                                        </div>
                                                    </div>

                                                    <div className="solar-obligations">
                                                        <h3 className="text-sm font-semibold mb-2">Assume Solar Obligations</h3>
                                                        <div className="flex items-center space-x-2">
                                                            <input
                                                                type="checkbox"
                                                                id={`${item}-assumeSolarObligations`}
                                                                checked={data.assumeSolarObligations}
                                                                onChange={() => handleCheckboxChange(item, 'assumeSolarObligations')}
                                                                onClick={handleCheckboxClick}
                                                                className="rounded focus:ring-blue-500"
                                                            />
                                                            <label className="md:text-[14px] text-[13px] text-gray-700" htmlFor={`${item}-assumeSolarObligations`}>Check if you will assume the solar power plan obligation.</label>
                                                        </div>
                                                    </div> 
                                                </div>
                                            )}
                                        </div>
                                    )}
                                    {(item === 'waterRights' || item === 'wellRights') && data.inclusionsPreStep && data.inclusionsPreStep[item] && (
                                        <div className="flex items-center md:space-x-2 space-x-1">
                                            <input
                                                type="checkbox"
                                                value="included"
                                                id={`${item}-included`}
                                                checked={data.inclusionsPreStep[item].included}
                                                onChange={() => handleItemToggle(item)}
                                            />
                                            <label className="md:text-[16px] text-[14px]" htmlFor={`${item}-included`}>Included</label>
                                        </div>
                                    )}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

            <div className="flex w-full justify-center gap-10 md:gap-36 mt-2 bg-white">
                <button className="w-[100px] md:w-[150px] justify-center text-center text-shi-green bg-white border-white text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-slate-200 items-center md:items-start flex" onClick={handleBack}>
                    Back
                </button>
                <button className="w-[100px] md:w-[150px] justify-center items-center text-center text-white bg-shi-green text-[16px] md:text-lg font-normal font-['Inter'] p-1.5 rounded-md border hover:bg-green-950 md:items-start flex" onClick={onNext}>
                    Next
                </button>
            </div>
        </MainCard>
        {isAssistVisible && (
                <div className="w-full md:w-auto absolute bottom-1 md:right-4">
                    <ShishitoAssist onClose={toggleAssist}/>
                </div>
            )}
        </div>
    )
}

export default PreStepMiscellaneous; 